import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import apkVersion from 'assets/dashboard/apkVersion.png';
import web from 'assets/dashboard/web.png';
import app from 'assets/dashboard/app.png';
import logs from 'assets/dashboard/logs.png';

import ApkVersionDashboard from './apkVersionInfo';
import WebsiteUpdateDashboard from './websiteUpdateInfo';
import WebsiteUpdateDashboardV2 from './websiteUpdateInfoV2';
import AppUpdateDashboard from './appUpdateInfo';
import SubAppUpdateDashboard from './subAppUpdateInfo';
import SubAppUpdateLogsDashboard from './subAppUpdateLogs';
import SuperAppUpdateLogsDashboard from './superAppUpdateLogs';

export const APK_UPDATE_RESOURCES = {
	apkVersionInfo: 'apkVersionInfo',
	websiteUpdateInfo: 'websiteUpdateInfo',
	websiteUpdateInfoV2: 'websiteUpdateInfoV2',
	appUpdateInfo: 'appUpdateInfo',
	subAppUpdateInfo: 'subAppUpdateInfo',
	subAppUpdateLogs: 'subAppUpdateLogs',
	superAppUpdateLogs: 'superAppUpdateLogs'
};

export const URL = {
	[APK_UPDATE_RESOURCES.apkVersionInfo]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.apkUpdateInfo}/${APK_UPDATE_RESOURCES.apkVersionInfo}`,
	[APK_UPDATE_RESOURCES.websiteUpdateInfo]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.apkUpdateInfo}/${APK_UPDATE_RESOURCES.websiteUpdateInfo}`,
	[APK_UPDATE_RESOURCES.websiteUpdateInfoV2]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.apkUpdateInfo}/${APK_UPDATE_RESOURCES.websiteUpdateInfoV2}`,
	[APK_UPDATE_RESOURCES.appUpdateInfo]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.apkUpdateInfo}/${APK_UPDATE_RESOURCES.appUpdateInfo}`,
	[APK_UPDATE_RESOURCES.subAppUpdateInfo]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.apkUpdateInfo}/${APK_UPDATE_RESOURCES.subAppUpdateInfo}`,
	[APK_UPDATE_RESOURCES.subAppUpdateLogs]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.apkUpdateInfo}/${APK_UPDATE_RESOURCES.subAppUpdateLogs}`,
	[APK_UPDATE_RESOURCES.superAppUpdateLogs]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.apkUpdateInfo}/${APK_UPDATE_RESOURCES.superAppUpdateLogs}`
};

export const LABEL = {
	[APK_UPDATE_RESOURCES.apkVersionInfo]: 'Version',
	[APK_UPDATE_RESOURCES.websiteUpdateInfo]: 'Web Oreo',
	[APK_UPDATE_RESOURCES.websiteUpdateInfoV2]: 'Web Performance',
	[APK_UPDATE_RESOURCES.appUpdateInfo]: 'SuperApp Updates',
	[APK_UPDATE_RESOURCES.subAppUpdateInfo]: 'SubApp Updates',
	[APK_UPDATE_RESOURCES.superAppUpdateLogs]: 'Super App Update Logs',
	[APK_UPDATE_RESOURCES.subAppUpdateLogs]: 'SubApp Update Logs'
};

export const COMPONENT = {
	[APK_UPDATE_RESOURCES.apkVersionInfo]: ApkVersionDashboard,
	[APK_UPDATE_RESOURCES.websiteUpdateInfo]: WebsiteUpdateDashboard,
	[APK_UPDATE_RESOURCES.websiteUpdateInfoV2]: WebsiteUpdateDashboardV2,
	[APK_UPDATE_RESOURCES.appUpdateInfo]: AppUpdateDashboard,
	[APK_UPDATE_RESOURCES.subAppUpdateInfo]: SubAppUpdateDashboard,
	[APK_UPDATE_RESOURCES.superAppUpdateLogs]: SuperAppUpdateLogsDashboard,
	[APK_UPDATE_RESOURCES.subAppUpdateLogs]: SubAppUpdateLogsDashboard
};

export const GET_ACTION = {
	[APK_UPDATE_RESOURCES.apkVersionInfo]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].getApkVersions,
	[APK_UPDATE_RESOURCES.websiteUpdateInfo]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].getWebsiteUpdates,
	[APK_UPDATE_RESOURCES.websiteUpdateInfoV2]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].getWebsiteUpdatesV2,
	[APK_UPDATE_RESOURCES.appUpdateInfo]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].getWebsiteUpdates,
	[APK_UPDATE_RESOURCES.subAppUpdateInfo]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].getWebsiteUpdates,
	[APK_UPDATE_RESOURCES.superAppUpdateLogs]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].getSuperAppUpdateLogs,
	[APK_UPDATE_RESOURCES.subAppUpdateLogs]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].getSubAppUpdateLogs
};

export const IMAGE_SOURCE = {
	[APK_UPDATE_RESOURCES.apkVersionInfo]: apkVersion,
	[APK_UPDATE_RESOURCES.websiteUpdateInfo]: web,
	[APK_UPDATE_RESOURCES.websiteUpdateInfoV2]: web,
	[APK_UPDATE_RESOURCES.appUpdateInfo]: app,
	[APK_UPDATE_RESOURCES.subAppUpdateInfo]: app,
	[APK_UPDATE_RESOURCES.superAppUpdateLogs]: logs,
	[APK_UPDATE_RESOURCES.subAppUpdateLogs]: logs
};

export const APK_UPDATE_ZK_VALUES = {
	keyName: 'appUpdateConfig',
	subAppkeyNames: ['SNLT', 'CARROM', 'TC', 'ZKJ', 'HC'],
	serviceName: 'SUPERAPP.SERVICE'
};

export const APK_UPDATE_SEGMENT_ZK_VALUES = {
	keyName: 'appUpdateConfigOnSegmentsV2',
	serviceName: 'SUPERAPP.SERVICE'
};

export enum EWebsiteUpdateDashBoardURL {
	GET_DASHBOARD_NAME = '/marketing/dashboard/apkUpdateInfo/getDashBoardsName',
	GET_TESTBUCKETS_NAME = '/marketing/dashboard/apkUpdateInfo/getTestBucketsName',
	GET_WEBSITE_UPDATES_V2 = '/marketing/dashboard/apkUpdateInfo/getWebsiteUpdatesV2',
	ADD_WEBSITE_UPDATE_INFO_V2 = '/marketing/dashboard/apkUpdateInfo/addWebsiteUpdateInfoV2',
	UPDATE_WEBSITE_UPDATE_INFO_V2 = '/marketing/dashboard/apkUpdateInfo/updateWebsiteUpdateInfoV2',
	DEPLOY_WEBSITE_UPDATES_V2 = '/marketing/dashboard/apkUpdateInfo/deployWebsiteUpdateV2'
}
